export const ONRAMPER_QUERY_PARAM = (): { [key: string]: string } => {
    return {
        "apiKey": "pk_prod_01H0ME3CQW1ECHXFEFPKW6QT9B",
        "onlyCryptos": "BNB_BSC",
        "defaultAmount": "100", //TO DELETE
        "defaultFiat": "USD",
        "onlyFiats": "USD",
        "isAmountEditable": "false",
        "networkWallets": "BSC:",
        "isAddressEditable": "false",
        "partnerContext": "",
    }
}
// apiKey=pk_prod_01H0ME3CQW1ECHXFEFPKW6QT9B&onlyCryptos=BNB_BSC&defaultAmount=100&defaultFiat=USD

export const convertJSONToQueryParam = (json): string => {
    let queryString: string = '';

    for (let key in json) {
        if (json.hasOwnProperty(key)) {
            queryString += `${key}=${json[key]}&`;
        }
    }
    queryString = queryString.slice(0, -1);
    return queryString;
}